import React, {useState} from "react"
import axios from "axios"
import {SERVER_URI} from "../utility/config"

export const ReservationManagement = (props) => {
	const {dayShiftTime, nightShiftTime, driverMaxShiftReservationDays} = props
	const [dayShiftStart, setDayShiftStart] = useState(new Date(dayShiftTime.dayShiftStart
	                                                            ? dayShiftTime.dayShiftStart
	                                                            : ""))
	const [dayShiftEnd, setDayShiftEnd] = useState(new Date(dayShiftTime.dayShiftEnd ? dayShiftTime.dayShiftEnd : ""))
	const [nightShiftStart, setNightShiftStart] = useState(new Date(nightShiftTime.nightShiftStart
	                                                                ? nightShiftTime.nightShiftStart
	                                                                : ""))
	const [nightShiftEnd, setNightShiftEnd] = useState(new Date(nightShiftTime.nightShiftEnd
	                                                            ? nightShiftTime.nightShiftEnd
	                                                            : ""))
	const [reservationDeadline, setReservationDeadline] = useState(driverMaxShiftReservationDays || 0)
	const [minimumShiftCancelTime, setMinimumShiftCancelTime] = useState(props.minimumShiftCancelTime || 0)
	const [minimumShiftReservationTime, setMinimumShiftReservationTime] = useState(props.minimumShiftReservationTime || 0)

	console.log("DayShiftStart", dayShiftStart)
	console.log("DayShiftStart.getTime()", dayShiftStart.getTime())

	const handleSave = async () => {
		/*const dayShiftRange = `${convertLocalTimeToUtcString(dayShift.start)}-${convertLocalTimeToUtcString(dayShift.end)}`
		const nightShiftRange = `${convertLocalTimeToUtcString(nightShift.start)}-${convertLocalTimeToUtcString(nightShift.end)}`*/

		console.log("DayShiftStart", dayShiftStart.toISOString())
		console.log("DayShiftEnd", dayShiftEnd)
		console.log("NightShiftStart", nightShiftStart)
		console.log("NightShiftEnd", nightShiftEnd)


		try {
			await axios({
				method:  "PUT",
				url:     `${SERVER_URI}/set_day_shift_time/`,
				data:    {dayShiftStart: dayShiftStart.toISOString(), dayShiftEnd: dayShiftEnd.toISOString()},
				headers: {Authorization: `Token ${localStorage.getItem("admin_token")}`},
			})
			props.dispatch({
				type: "UPDATE_DAY_SHIFT_TIME", data: {dayShiftStart: dayShiftStart.toISOString(), dayShiftEnd: dayShiftEnd.toISOString()},
			})
			await axios({
				method:  "PUT",
				url:     `${SERVER_URI}/set_night_shift_time/`,
				data:    {nightShiftStart: nightShiftStart.toISOString(), nightShiftEnd: nightShiftEnd.toISOString()},
				headers: {Authorization: `Token ${localStorage.getItem("admin_token")}`},
			})
			props.dispatch({
				type: "UPDATE_NIGHT_SHIFT_TIME", data: {nightShiftStart: nightShiftStart.toISOString(), nightShiftEnd: nightShiftEnd.toISOString()},
			})
			await axios({
				method:  "PUT",
				url:     `${SERVER_URI}/set_driver_max_shift_reservation_days/`,
				data:    {driverMaxShiftReservationDays: parseInt(reservationDeadline)},
				headers: {Authorization: `Token ${localStorage.getItem("admin_token")}`},
			})
			props.dispatch({
				type: "UPDATE_DRIVER_MAX_SHIFT_RESERVATION_DAYS",
				data: {newDriverMaxShiftReservationDays: parseInt(reservationDeadline)},
			})
			await axios({
				method:  "PUT",
				url:     `${SERVER_URI}/set_minimum_shift_cancel_time/`,
				data:    {minimumShiftCancelTime: parseInt(minimumShiftCancelTime)},
				headers: {Authorization: `Token ${localStorage.getItem("admin_token")}`},
			})
			props.dispatch({
				type: "UPDATE_MINIMUM_SHIFT_CANCEL_TIME",
				data: {newMinimumShiftCancelTime: parseInt(minimumShiftCancelTime)},
			})
			await axios({
				method:  "PUT",
				url:     `${SERVER_URI}/set_minimum_shift_reservation_time/`,
				data:    {minimumShiftReservationTime: parseInt(minimumShiftReservationTime)},
				headers: {Authorization: `Token ${localStorage.getItem("admin_token")}`},
			})
			props.dispatch({
				type: "UPDATE_MINIMUM_SHIFT_RESERVATION_TIME",
				data: {newMinimumShiftReservationTime: parseInt(minimumShiftReservationTime)},
			})
			alert("Asetukset tallennettu onnistuneesti.")
		} catch (err) {
			console.error("Error saving reservation settings:", err)
			alert("Virhe asetusten tallennuksessa. Tarkista konsoli virheen yksityiskohdista.")
		}
	}

	return (<div className="configurations">
		<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
			Päivävuoro:
			<input type="time" id="dayShiftStart" value={`${String(dayShiftStart.getHours()).padStart(2, '0')}:${String(dayShiftStart.getMinutes()).padStart(2, '0')}`}
			       onChange={(e) => {
				       const newTime = new Date()
				       newTime.setHours(e.target.value.split(":")[0])
				       newTime.setMinutes(e.target.value.split(":")[1])
				       setDayShiftStart(newTime)
			       }}/>
			<span> - </span>
			<input type="time" id="dayShiftEnd" value={`${String(dayShiftEnd.getHours()).padStart(2, '0')}:${String(dayShiftEnd.getMinutes()).padStart(2, '0')}`}
			       onChange={(e) => {
							 				       const newTime = new Date()
				       newTime.setHours(e.target.value.split(":")[0])
				       newTime.setMinutes(e.target.value.split(":")[1])
				       setDayShiftEnd(newTime)
			       }}/>
		</div>
		<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
			Yövuoro:
			<input type="time" id="nightShiftStart" value={`${String(nightShiftStart.getHours()).padStart(2, '0')}:${String(nightShiftStart.getMinutes()).padStart(2, '0')}`}
			       onChange={(e) => {
							 				       const newTime = new Date()
				       newTime.setHours(e.target.value.split(":")[0])
				       newTime.setMinutes(e.target.value.split(":")[1])
				       setNightShiftStart(newTime)
			       }}/>
			<span> - </span>
			<input type="time" id="nightShiftEnd" value={`${String(nightShiftEnd.getHours()).padStart(2, '0')}:${String(nightShiftEnd.getMinutes()).padStart(2, '0')}`}
			       onChange={(e) => {
							 				       const newTime = new Date()
				       newTime.setHours(e.target.value.split(":")[0])
				       newTime.setMinutes(e.target.value.split(":")[1])
				       setNightShiftEnd(newTime)
			       }}/>
		</div>
		<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
			Varausten takaraja (päivää):
			<input type="number" id="reservationDeadline" value={reservationDeadline}
			       onChange={(e) => setReservationDeadline(e.target.value)} min="0" max="30"/>
			<span> päivää</span>
		</div>
		<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
			Vähimmäisperuutusaika (tuntia):
			<input type="number" id="minimumShiftCancelTime" value={minimumShiftCancelTime}
			       onChange={(e) => setMinimumShiftCancelTime(e.target.value)} min="0" max="1440"/>
			<span> tuntia</span>
		</div>
		<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
			Vähimmäisvarausaika (tuntia):
			<input type="number" id="minimumShiftReservationTime" value={minimumShiftReservationTime}
			       onChange={(e) => setMinimumShiftReservationTime(e.target.value)} min="0" max="1440"/>
			<span> tuntia</span>
		</div>
		<button id="gradient_Button" onClick={handleSave}>Tallenna</button>
	</div>)
}